<template>
	<div
		class="w-full px-4 lg:px-8 bg-white rounded-2xl border border-slate-100 lg:border-none relative overflow-hidden"
	>
		<div
			ref="titleRef"
			class="py-4 sticky top-0 border-b z-10 bg-white border-slate-100"
		>
			<QuoteCardTitle>
				News & Analysis
			</QuoteCardTitle>
		</div>

		<template v-if="news.length > 0">
			<div
				class="relative lg:grid grid-cols-1 md:grid-cols-2 transition-all duration-300 ease-in-out py-4 scrollbar-hide lg:overflow-visible"
				:class="{
					'h-[360px] overflow-hidden': !showAll && !isDesktop,
					'h-[576px] overflow-hidden': !showAll && isDesktop && news.length > 8,
					'overflow-auto': showAll
				}"
			>
				<div
					v-for="(item, idx) in news"
					:key="'left-' + idx"
					:class="[
						'flex items-start gap-4 ',
						idx % 2 === 0 ? 'lg:pr-4 lg:border-r border-slate-200' : 'lg:pl-4'
					]"
				>
					<NuxtLink
						class="flex items-start gap-4 border-slate-200 py-4 w-full justify-between"
						:class="{
							'border-t': idx !== 0 && idx !== 1 && isDesktop,
							'border-b': !isDesktop && idx !== news.length - 1,
							'lg:pt-0': idx === 0 || idx === 1,
							'pt-0': idx === 0 && !isDesktop,
							'lg:pb-0': idx === news.length - 1 || idx === news.length - 2
						}"
						:href="`/news/${item.slug}/`"
					>
						<div class="flex flex-col justify-center h-full">
							<h4
								class="block font-medium text-lg lg:text-xl leading-snug text-slate-900 hover:underline mb-1"
								v-html="item.title"
							></h4>
							<div class="text-slate-400 text-[15px] mt-2">
								{{ item.author }} · {{ item.date }}
							</div>
						</div>
						<img
							v-if="item.image"
							:src="`${hostname}cdn-cgi/image/quality=100,format=webp,width=320/${item.image}`"
							alt=""
							class="w-[120px] h-[120px] object-cover lg:rounded-sm flex-shrink-0 ml-auto"
						/>
					</NuxtLink>
				</div>
			</div>

		<ShowMore
			v-if="(news.length > 3 && !isDesktop) || (news.length > 8 && isDesktop)"
			class="h-16 pt-0 lg:pt-6"
			:class="{
				relative: showAll
			}"
			variant="primary"
			:is-expanded="showAll"
			@click="toggleShowAll"
		/>
		</template>

		<div
			v-else
			class="flex flex-col text-base text-center py-8 text-slate-400"
		>
			No news and analysis data available
		</div>
	</div>
</template>

<script setup>
import { useBreakpoints } from "@vueuse/core";
import { NuxtLink } from "#components";

defineProps({
	news: {
		type: Array,
		required: true
		// Each item: { title, url, author, date, image }
	}
});

const breakpoints = useBreakpoints({
	large: 1280,
	md: 1024,
	small: 768
});

const hostname = useRuntimeConfig().public.hostname;
const showAll = ref(false);

const toggleShowAll = () => {
	showAll.value = !showAll.value;
};

const isDesktop = computed(() => breakpoints.isGreaterOrEqual("md"));
</script>
